// Age Validation on cart drawer.
var has_already_checked = false;
window.ageValidation = function() {
  const checkBoxes = document.querySelectorAll("#age_validation, #age_validation_cart");
  const checkOutButtons = document.querySelectorAll("#checkout");

  if (!checkBoxes.length) return;

  checkBoxes.forEach(checkBox => {
    checkOutButtons.forEach((btn, index) => {
      if(has_already_checked) checkBoxes[index].checked = true;
      btn.disabled = !has_already_checked;
    });
    checkBox.addEventListener("input", () => {
      const atLeastOneChecked = [...checkBoxes].some(box => box.checked);
      checkOutButtons.forEach(btn => {
        btn.disabled = !atLeastOneChecked;
        has_already_checked = atLeastOneChecked;
      });
    });
  });
}

window.ageValidation();


async function fetchCart() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const responseData = await response.json();
  return responseData;
}

window.freeGiftCardValidation = function(){
  const checkBoxes = document.querySelectorAll("#gift_card_validation, #gift_card_validation_cart");

  if (!checkBoxes.length) return;

  checkBoxes.forEach(checkBox => {
    checkBox.addEventListener("input", () => {
      const isChecked = checkBox.checked;
      window.addFreeGiftProduct(isChecked);
    });
  });
}

window.addFreeGiftProduct = async function(isChecked){
  const free_gift_card_product = window.themes.free_gift_card_product.product;
  const has_free_gift_card_product = free_gift_card_product.error ? false : true;
  if(!has_free_gift_card_product) return;
  const selected_id = free_gift_card_product.variants[0].id;
  const cartJson = await fetchCart();

  const itemsArray = [];
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if(isChecked){
    itemsArray.push({
      id: selected_id,
      quantity: 1
    });
    const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers);
    const data = await response.json();
    if(window.location.pathname.includes('cart')){
      window.location.reload();
    } else{
      cart.renderContents(data);
    }
  } else{
    const updates = { [selected_id]: 0 };
    const updateHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({updates}) };
    const updateCartResponse =  await fetch(`${window.Shopify.routes.root}cart/update.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, updateHeaders);
    const data = await updateCartResponse.json();
    if(window.location.pathname.includes('cart')){
      window.location.reload();
    } else{
      cart.renderContents(data);
    }
  }
}

window.freeGiftCardValidation();


var trustedCounter = 0;
var maxAttempts = 10;

window.TrustBadgeStyleUpdate = function() {
  const trustedBadgeEle = document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810');
  
  if (trustedBadgeEle) {
    clearInterval(getTrustInterval);
    trustedBadgeEle.style.cssText = 'z-index: 1; position: fixed;'
  } else {
    if (trustedCounter >= maxAttempts) {
      clearInterval(getTrustInterval);
    } else {
      trustedCounter++;
      setTimeout(window.TrustBadgeStyleUpdate, 500);
    }
  }
}

var getTrustInterval = setTimeout(window.TrustBadgeStyleUpdate, 1000);

// close Cart Drawer on Outer Click
window.closeCartDrawer = function(){
  const cartDrawer = document.querySelector('cart-drawer');
  if(cartDrawer){
    cartDrawer.querySelector('#CartDrawer-Overlay').addEventListener('click',(e)=>{
       cartDrawer.close(cartDrawer);
    });
  }
}
window.closeCartDrawer();

var wishlistCounter = 0;
var _maxAttempts = 5;
function renderWishlistIconHeader(){
  const wishlist_icon = document.querySelector('.swym-wishlist.header__icon');
  if(wishlist_icon){
    if(wishlist_icon.hasAttribute('data-swym-loaded')){
      wishlist_icon.style.display = '';
      clearInterval(getWishlistInterval);
    } else{
      wishlist_icon.style.display = 'none';
      if (wishlistCounter >= _maxAttempts) {
        clearInterval(getWishlistInterval);        
      } else {
        wishlistCounter++;
        getWishlistInterval = setInterval(renderWishlistIconHeader, 200);
      }
    }
  }
}
var getWishlistInterval = setInterval(renderWishlistIconHeader, 500);


// var rechargeCounter = 0;
// window.rechargeWidgetPriceUpdate = function() {
//   const mainRechargeWidgetContainer = document.querySelectorAll('recharge-subscription-widget');
//   if (mainRechargeWidgetContainer.length > 0) {
//     clearInterval(rechargeInterval);
//     console.log("Recharge widget found. Interval cleared.");
//     mainRechargeWidgetContainer.forEach(widgetContainer=>{
//       const shadowRoot = widgetContainer.shadowRoot;
//       if(shadowRoot){
//         const allInputs = shadowRoot.querySelectorAll('.rc-purchase-option__input');
//         if(allInputs.length > 0){
//           allInputs.forEach(input=>{
//             input.addEventListener('change', ()=>{updatePrice(input, widgetContainer)});
//           })
//         }
//       }
//     })
//   } else {
//     rechargeCounter += 1;
//     if (rechargeCounter >= 10) {
//       clearInterval(rechargeInterval);
//       console.log("Max attempts reached. Interval cleared.");
//     }
//   }
// }

// function updatePrice(currentTarget, widgetContainer){
//   const MainProductContainer = widgetContainer?.closest('.product__info-wrapper');
//   console.log(MainProductContainer);
// }

// // Start the interval to check for the widget every second
// var rechargeInterval = setInterval(window.rechargeWidgetPriceUpdate, 1000);


const testDetails = document.querySelectorAll(".menu_content_with_product details");
  if(testDetails.length){    
    testDetails.forEach((currentDetail) => {
      currentDetail.addEventListener("toggle", () => {
        if (currentDetail.open) {
          testDetails.forEach((detail) => {
            if (detail !== currentDetail) {
              detail.open = false;
            }
          });
        }
      });
    }); 
  }


function updSwiperNumericPagination() {
  this.el.querySelector('.swiper-counter').innerHTML =
    '<span class="count">' +
    (this.realIndex + 1) +
    '</span>/<span class="total">' +
    this.el.slidesQuantity +
    '</span>';
}

document.addEventListener('DOMContentLoaded', function () {

  // --------- Readmore Functionality -----------
  const readMoreBtns = document.querySelectorAll('.read-more-btn');

  readMoreBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const shortText = this.parentElement.querySelector('.short-text');
      const fullText = this.parentElement.querySelector('.full-text');

      if (shortText && fullText && shortText.style.display !== 'none') {
        shortText.style.display = 'none';
        fullText.style.display = 'inline';
        this.innerText = 'Read less';
      } else{
        shortText.style.display = 'inline';
        fullText.style.display = 'none';
        this.innerText = 'Read more';
      }
    });
  });

  document.querySelectorAll('.collection-slider').forEach(function (node) {
    // Getting slides quantity before slider clones them
    node.slidesQuantity = node.querySelectorAll('.swiper-slide').length;

    // Swiper initialization
    new Swiper(node, {
      slidesPerView: 1.5,
      spaceBetween: 16,
      speed: 600,
      loop: true,
      autoplay: false,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        // Secondary pagination is update after initialization and after slide change
        init: updSwiperNumericPagination,
        slideChange: updSwiperNumericPagination,
      },
      breakpoints: {
        569: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      }
    });
  });

  document.querySelectorAll('.testimonial-box-wrapper').forEach(function (node) {
    // Getting slides quantity before slider clones them
    node.slidesQuantity = node.querySelectorAll('.swiper-slide').length;

    // Swiper initialization
    new Swiper(node, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 600,
      loop: true,
      autoplay: false,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        // Secondary pagination is update after initialization and after slide change
        init: updSwiperNumericPagination,
        slideChange: updSwiperNumericPagination,
      },
      breakpoints: {
        569: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      }
    });
  });


  window.complementarySlider = function() {
    console.log('complementarySlider');
    document.querySelectorAll('.comp_swiper').forEach(function (node) {
      // Getting slides quantity before slider clones them
      node.slidesQuantity = node.querySelectorAll('.swiper-slide').length;

      // Swiper initialization
      new Swiper(node, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        autoplay: false,
        draggable: true,
        breakpoints: {
          1199: {
            slidesPerView: 1.41,
          },
          920: {
            slidesPerView: 1.1,
          },
        },
      });
    });
  }
  // window.complementarySlider();
});


// Swiper Slider Settings

document.addEventListener('DOMContentLoaded', function () {
  function destroySwiper(swiper) {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  }

  function generateUniqueId() {
    return 'swiper-' + Math.random().toString(36).substr(2, 9);
  }

  function initSwiper(slider) {
    var desktopColumns = parseInt(slider.getAttribute('desktop-column'));
    var tabletColumns = parseInt(slider.getAttribute('tablet-column'));
    var mobileColumns = parseInt(slider.getAttribute('mobile-column'));
    var enablePagination = slider.getAttribute('pagination');
    var enableArrows = slider.getAttribute('arrows');
    var enableScrollbar = slider.getAttribute('scrollbar');
    var enableAutoplay = slider.getAttribute('autoplay') === 'true';
    var autoplayDelay = parseInt(slider.getAttribute('slider-delay'));
    var enableLoop = slider.getAttribute('loop') === 'true';
    var sliderSpaceBetween = parseInt(slider.getAttribute('slider-space-between'));

    var paginationId = generateUniqueId();
    var nextArrowId = generateUniqueId();
    var prevArrowId = generateUniqueId();
    var scrollbarId = generateUniqueId();

    var paginationEl = slider.querySelector('.swiper-pagination');
    var nextArrowEl = slider.querySelector('.swiper-button-next');
    var prevArrowEl = slider.querySelector('.swiper-button-prev');
    var scrollbarEl = slider.querySelector('.swiper-scrollbar');

    if (enablePagination && paginationEl) {
      paginationEl.id = paginationId;
    }
    if (enableArrows && nextArrowEl && prevArrowEl) {
      nextArrowEl.id = nextArrowId;
      prevArrowEl.id = prevArrowId;
    }
    if (enableScrollbar && scrollbarEl) {
      scrollbarEl.id = scrollbarId;
    }

    return new Swiper(slider, {
      slidesPerView: mobileColumns,
      spaceBetween: sliderSpaceBetween,
      pagination: enablePagination && paginationEl ? { el: `#${paginationId}`, clickable: true } : false,
      navigation: enableArrows && nextArrowEl && prevArrowEl ? {
        nextEl: `#${nextArrowId}`,
        prevEl: `#${prevArrowId}`,
      } : false,
      scrollbar: enableScrollbar && scrollbarEl ? { el: `#${scrollbarId}`, draggable: true } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      loop: enableLoop,
      breakpoints: {
        1025: {
          slidesPerView: desktopColumns,
        },
        768: {
          slidesPerView: tabletColumns,
        },
      },
    });
  }

  function loadSliders() {
    var sections = document.querySelectorAll('[id^="section-"]');

    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('.swiper-desktop-and-mobile, .swiper-desktop, .swiper-mobile');

      sliders.forEach(function (slider) {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var currentSwiper = slider.swiper;

        destroySwiper(currentSwiper);

        if (
          (slider.classList.contains('swiper-desktop-and-mobile')) ||
          (slider.classList.contains('swiper-desktop') && isDesktop) ||
          (slider.classList.contains('swiper-mobile') && isMobile)
        ) {
          slider.swiper = initSwiper(slider);
        }
      });
    });
  }

  function resizeSliders() {
    window.addEventListener('resize', function () {
      loadSliders();
    });
  }

  loadSliders();
  resizeSliders();
});


// Review video
// Store YouTube player instances
document.addEventListener('DOMContentLoaded', function () {
  const youtubePlayers = new Map();

  // Wait for YouTube API to be ready
  window.onYouTubeIframeAPIReady = () => {
    document.querySelectorAll('.review_img_video iframe[src*="youtube"]').forEach((iframe) => {
      const player = new YT.Player(iframe, {
        events: {
          onReady: () => {
            youtubePlayers.set(iframe, player);
          }
        }
      });
    });
  };

  document.querySelectorAll('.play_video').forEach(button => {
    button.addEventListener('click', function () {
      const parent = this.closest('.review_img_video');
      const iframe = parent.querySelector('iframe[src*="youtube"]');
      const video = parent.querySelector('video');

      // 🔁 Pause all other videos first
      document.querySelectorAll('.review_img_video').forEach(other => {
        if (other !== parent) {
          // Pause YouTube iframe if exists
          const otherIframe = other.querySelector('iframe[src*="youtube"]');
          if (otherIframe && youtubePlayers.has(otherIframe)) {
            youtubePlayers.get(otherIframe).pauseVideo();
          }

          // Pause native video if exists
          const otherVideo = other.querySelector('video');
          if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
          }

          other.classList.remove('playing');
          other.classList.remove('played');
        }
      });

      // ▶️ Play clicked video
      if (iframe && youtubePlayers.has(iframe)) {
        const player = youtubePlayers.get(iframe);
        const isPlaying = parent.classList.contains('playing');

        if (isPlaying) {
          player.pauseVideo();
          parent.classList.remove('playing');
          parent.classList.remove('played');
        } else {
          player.playVideo();
          parent.classList.add('playing');
          parent.classList.add('played');
        }

      } else if (video) {
        if (video.paused) {
          video.play();
          parent.classList.add('playing');
          parent.classList.add('played');
        } else {
          video.pause();
          parent.classList.remove('playing');
          parent.classList.remove('played');
        }

        // These listeners can be set once per video in setup if needed
        video.addEventListener('play', () => parent.classList.add('playing'));
        video.addEventListener('pause', () => parent.classList.remove('playing'));
      } else {
        parent.classList.toggle('playing');
        parent.classList.toggle('played');
      }

      if (!parent.classList.contains('played')) {
        parent.classList.add('played');
      }
    });
  });
});



// // Custom Sort By filter on collection page
// function initializeCustomSelect(customSelectContainer) {
//   if (!customSelectContainer) return;

//   const selectedTrigger = customSelectContainer.querySelector('.custom-select__selected');
//   const dropdownList = customSelectContainer.querySelector('.custom-select__list');
//   const sortOptions = customSelectContainer.querySelectorAll('.custom-select__item');

//   if (!selectedTrigger || !dropdownList) return;

//   selectedTrigger.addEventListener('click', function() {
//     this.classList.toggle('active');
//     dropdownList.classList.toggle('show');
//   });

//   if (sortOptions.length > 0) {
//     sortOptions.forEach(option => {
//       option.addEventListener('click', updateSortByFilter.bind(this));
//     });
//   }

//   if (!window.customSelectOutsideClickHandler) {
//     window.customSelectOutsideClickHandler = function(event) {
//       if (!customSelectContainer.contains(event.target)) {
//         selectedTrigger.classList.remove('active');
//         dropdownList.classList.remove('show');
//       }
//     };
//     document.addEventListener('click', window.customSelectOutsideClickHandler);
//   }
// }

// function updateSortByFilter(event) {
//   const _this = event.target;
//   const optionValue = _this?.getAttribute('data-value');
//   const sortingSelect = document.querySelector('.facet-filters.sorting select');

//   if (!sortingSelect) return;
//   sortingSelect.value = optionValue;

//   const changeEvent = new Event('input', {
//     bubbles: true,
//     cancelable: true
//   });

//   const facetForm = sortingSelect.closest('facet-filters-form');
//   const form = sortingSelect.closest('form');

//   if (facetForm && form) {
//     const observer = new MutationObserver((mutations, obs) => {
//       const customSelectContainer = facetForm.querySelector('.custom-select');
//       if (customSelectContainer) {
//         initializeCustomSelect(customSelectContainer);
//         obs.disconnect();
//       }
//     });

//     observer.observe(facetForm, {
//       childList: true,
//       subtree: true,
//       attributes: true
//     });

//     form.dispatchEvent(changeEvent);
//   }
// }

// // Update the DOMContentLoaded event listener
// document.addEventListener('DOMContentLoaded', () => {
//   const customSelect = document.querySelector('.custom-select');
//   initializeCustomSelect(customSelect);
// });

// // visible all the hidden filters
// document.addEventListener('DOMContentLoaded', () => {
//   const allReadMoreBtn = document.querySelectorAll('.ReadMoreBtn');
//   if(allReadMoreBtn.length > 0){
//     allReadMoreBtn.forEach(btn=>{
//       btn.addEventListener('click', visibleFilter.bind(this));
//     })
//   }
// });

// function visibleFilter(evt){
//   const _this = evt.target;
//   const closestUL = _this?.closest('ul');
//   if(closestUL){
//     const AllGreaterMinValueDiv = closestUL?.querySelectorAll('.greater-min-value');
//     if(AllGreaterMinValueDiv.length > 0){
//       AllGreaterMinValueDiv.forEach(div=>{
//         if(div.classList.contains('hidden')){
//           div.classList.remove('hidden');
//           _this.innerText = 'Read Less';
//         }else{
//           div.classList.add('hidden');
//           _this.innerText = 'Read More';
//         }
//       })
//     }
//   }
// }

// Make the sort by function available globally
window.handleSortByClick = function (evt) {
  evt.preventDefault();
  const _this = evt.currentTarget;
  const optionValue = _this?.getAttribute('data-value');
  const sortingSelect = document.querySelector('.facet-filters.sorting select');

  if (!sortingSelect) return;
  sortingSelect.value = optionValue;

  const changeEvent = new Event('input', {
    bubbles: true,
    cancelable: true
  });

  const form = sortingSelect.closest('form');
  if (form) {
    form.dispatchEvent(changeEvent);
  }
};

// Make the visible filter function available globally
window.visibleFilter = function (evt) {
  evt.preventDefault();
  const _this = evt.currentTarget;
  const closestUL = _this?.closest('ul');
  if (closestUL) {
    const AllGreaterMinValueDiv = closestUL?.querySelectorAll('.greater-min-value');
    if (AllGreaterMinValueDiv.length > 0) {
      AllGreaterMinValueDiv.forEach(div => {
        if (div.classList.contains('hidden')) {
          div.classList.remove('hidden');
          _this.innerText = 'View Less';
        } else {
          div.classList.add('hidden');
          _this.innerText = 'View More...';
        }
      })
    }
  }
};

// Function to initialize read more buttons
function initializeReadMoreButtons() {
  const allReadMoreBtn = document.querySelectorAll('.ReadMoreBtn');
  if (allReadMoreBtn.length > 0) {
    allReadMoreBtn.forEach(btn => {
      btn.removeEventListener('click', window.visibleFilter);
      btn.addEventListener('click', window.visibleFilter);
    });
  }
}

// Function to initialize custom select
function initializeCustomSelect(customSelectContainer) {
  if (!customSelectContainer) return;

  const selectedTrigger = customSelectContainer.querySelector('.custom-select__selected');
  const dropdownList = customSelectContainer.querySelector('.custom-select__list');
  const sortOptions = customSelectContainer.querySelectorAll('.custom-select__item');

  if (!selectedTrigger || !dropdownList) return;

  selectedTrigger.removeEventListener('click', null);
  selectedTrigger.addEventListener('click', function () {
    this.classList.toggle('active');
    dropdownList.classList.toggle('show');
  });

  if (sortOptions.length > 0) {
    sortOptions.forEach(option => {
      option.removeEventListener('click', window.handleSortByClick);
      option.addEventListener('click', window.handleSortByClick);
    });
  }

  window.customSelectOutsideClickHandler = function (event) {
    if (!customSelectContainer.contains(event.target)) {
      selectedTrigger.classList.remove('active');
      dropdownList.classList.remove('show');
    }
  };
  document.addEventListener('click', window.customSelectOutsideClickHandler);
}

document.addEventListener('DOMContentLoaded', () => {
  initializeCustomSelect(document.querySelector('.custom-select'));
  initializeReadMoreButtons();
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      const facetForm = document.querySelector('facet-filters-form');
      if (facetForm && mutation.target.closest('details')) {
        initializeReadMoreButtons();
      }

      if (facetForm && mutation.target.closest('.facet-filters.sorting')) {
        initializeCustomSelect(document.querySelector('.custom-select'));
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


// -------- Accordian collapsible
document.addEventListener('DOMContentLoaded', function () {
  const details = document.querySelectorAll('.faq-section .accordion, .accordion-details');

  details.forEach((detail) => {
    detail.addEventListener('click', (e) => {
      if (e.target.hasAttribute('open')) {
        return;
      }

      details.forEach((otherDetail) => {
        if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
          otherDetail.removeAttribute('open');
        }
      });
    });
  });
});



// const allMenus = document.querySelectorAll('.header__menu-item');
//     console.log(allMenus);

//     allMenus.forEach((menuItem) => {
//       const parentMenu = menuItem.closest('.mega-menu');
//       const content = parentMenu?.querySelector('.mega-menu__content');

//       menuItem.addEventListener('mouseenter', () => {
//         document.querySelectorAll('.mega-menu').forEach((otherMenu) => {
//           if (otherMenu !== parentMenu) {
//             otherMenu.removeAttribute('open');
//             const otherItem = otherMenu.querySelector('.header__menu-item');
//             if (otherItem) {
//               otherItem.setAttribute('aria-expanded', 'false');
//             }
//           }
//         });

//         if (parentMenu) {
//           parentMenu.setAttribute('open', '');
//           menuItem.setAttribute('aria-expanded', 'true');
//         }
//       });
//     });

//     document.querySelectorAll('.mega-menu__content').forEach((content) => {
//       content.addEventListener('mouseleave', () => {
//         const parentMenu = content.closest('.mega-menu');
//         if (parentMenu) {
//           parentMenu.removeAttribute('open');
//           const menuItem = parentMenu.querySelector('.header__menu-item');
//           if (menuItem) {
//             menuItem.setAttribute('aria-expanded', 'false');
//           }
//         }
//       });
//     });



window.initializeSliderDots = function() {
  document.querySelectorAll('slider-component').forEach(function(sliderComponent) {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const slides = Array.from(sliderComponent.querySelectorAll('[data-slide-index]')).filter(
      slide => slide.style.display !== 'none'
    );
    const dotsContainer = sliderComponent.querySelector('.slider-dots');
    
    // Fix: Only proceed if dotsContainer exists
    if (!dotsContainer) return;

    // Create dots based on number of slides
    dotsContainer.innerHTML = '';
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `slider-dot${index === 0 ? ' active' : ''}`;
      dot.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`);
      dot.setAttribute('data-slide', index);
      
      const span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = `Slide ${index + 1} of ${slides.length}`;
      dot.appendChild(span);
      
      dot.addEventListener('click', () => {
        // Get the slide width to calculate scroll position
        const slideWidth = slides[0].offsetWidth;
        // Calculate the scroll position
        const scrollPosition = slideWidth * index;
        // Scroll to the position
        slider.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      });
      
      dotsContainer.appendChild(dot);
    });

    // Update active dot on scroll
    slider.addEventListener('scroll', function() {
      let bestIndex = 0;
      let minDiff = Infinity;
      const sliderRect = slider.getBoundingClientRect();
      
      slides.forEach((slide, idx) => {
        const rect = slide.getBoundingClientRect();
        const diff = Math.abs(rect.left - sliderRect.left);
        if (diff < minDiff) {
          minDiff = diff;
          bestIndex = idx;
        }
      });
      
      // Update active dot
      const dots = dotsContainer.querySelectorAll('.slider-dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === bestIndex);
      });
    });

    // Reset to first slide and update dots when variant changes
    slider.addEventListener('variantChange', function() {
      // Scroll to first slide
      slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
      
      // Update active dot
      const dots = dotsContainer.querySelectorAll('.slider-dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === 0);
      });
    });
  });
}

// Initialize dots on page load and when new sections are loaded
document.addEventListener('DOMContentLoaded', initializeSliderDots);
document.addEventListener('shopify:section:load', initializeSliderDots);

// Listen for variant changes
document.addEventListener('variantChange', initializeSliderDots);




// Price mattch height js for collection section
function matchheightprice() {
  const priceelement = document.querySelectorAll(".featured_collection .product-grid .card-wrapper .card-information > .price");
  let maxheight = 0;
  priceelement.forEach(el => {
    el.style.height = 'auto'; // reset
    const height = el.offsetHeight;
    if (height > maxheight) {
      maxheight = height;
    }
  });
  priceelement.forEach(el => {
    el.style.height = `${maxheight}px`;
  });
}
document.addEventListener("DOMContentLoaded", matchheightprice);
window.addEventListener("resize", matchheightprice);
  let resizetimeout;
window.addEventListener("resize", function () {
  clearTimeout(resizetimeout);
  resizetimeout = setTimeout(matchheightprice, 200); // delay of 200ms
});


  var swiperContainer = document.querySelector(".sub-collection_wrapper .swiper-container");


      // Initialize Swiper instance
      var mySwiper = new Swiper(swiperContainer, {
         slidesPerView: 4,
        // slidesPerView: "auto",
        
        
        loop: false,
        loopAdditionalSlides: 30,
        spaceBetween: 16.5,
        scrollbar: {
            el: '.sub_collection_list .js-collection-scrollbar',
            draggable: true,
            snapOnRelease: true
          },
        breakpoints: {
        569: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 8,
          spaceBetween: 38,
        },
      }

      });

// init Slider on Product Recommendation
window.ProductRecommendationInit = function(currentTarget) {
  if(!currentTarget) return;
  const numbeOfProductsToShow = parseInt(currentTarget?.getAttribute('data-number-products-show'));
  const numbeOfColumnsDesktop = parseInt(currentTarget?.getAttribute('data-number-desktop-columns'));
  const numbeOfColumnsMobile = parseInt(currentTarget?.getAttribute('data-number-mobile-columns'));
  const currentSliderEle = currentTarget.querySelector('.js-enable-slider');
  if (currentSliderEle && currentSliderEle.querySelectorAll) {
  currentSliderEle.slidesQuantity = currentSliderEle.querySelectorAll('.swiper-slide').length;
}
    if(currentSliderEle && numbeOfProductsToShow > numbeOfColumnsDesktop){
      new Swiper(currentSliderEle, {
        slidesPerView: numbeOfColumnsMobile,
        spaceBetween: 16,
        loop: false,
        autoplay: false,
        draggable: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          // Secondary pagination is update after initialization and after slide change
          init: updSwiperNumericPagination,
          slideChange: updSwiperNumericPagination,
        },
        breakpoints: {
          989: {
            slidesPerView: numbeOfColumnsDesktop,
          },
        },
      });
    }
  }


  function renderWishlistCounter(swat) {
	  var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Custom header can be added here.*/
    if (counter_elem) {
      for (var i = 0; i < counter_elem.length; i++) {
        if (swat.renderWishlistCount) {
          swat.renderWishlistCount(counter_elem[i], function(count, element) {
            // console.log("debug - renderWishlistCount", count, element); 
          });
        }
      }
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(renderWishlistCounter);



// bundle detail div height

// document.addEventListener("DOMContentLoaded", function () {
//   const items = document.querySelectorAll(".main-bundle-section .product_info-container"); // or adjust selector as needed
//   let maxHeight = 0;

//   // 1. Reset heights (in case it's run again)
//   items.forEach((item) => {
//     item.style.height = "auto";
//   });

//   // 2. Find max height
//   items.forEach((item) => {
//     const height = item.offsetHeight;
//     if (height > maxHeight) maxHeight = height;
//   });

//   // 3. Set all to max height
//   items.forEach((item) => {
//     item.style.height = maxHeight + "px";
//   });
// });

// Hide all the Other Sellingplans on product page
var SellingPlanCounter = 0;
var _maxSellingPlanAttempts = 5;
function renderSellingPlanContainer(){
  const rc_selling_plans = document.querySelector('recharge-subscription-widget');
  if(rc_selling_plans){
    const innerShadowRoot = rc_selling_plans.shadowRoot;
    if(innerShadowRoot){
      const innerMain = innerShadowRoot.querySelector('rc-selling-plans');
      if(innerMain){
        const InnerShadowRoot = innerMain.shadowRoot;
        if(InnerShadowRoot){
          const AllParts = InnerShadowRoot.querySelectorAll('[part="rc-plans-radio-button"]');
          if(AllParts.length > 0){
            for (let i = 4; i < AllParts.length; i++) {
              AllParts[i].style.display = 'none';
            }
            clearInterval(getWishlistInterval);
          }
        }
      }
    } else {
      SellingPlanCounter++;
      getWishlistInterval = setInterval(renderSellingPlanContainer, 200);
    }
  }
}
var getWishlistInterval = setInterval(renderSellingPlanContainer, 500);


  document.addEventListener("DOMContentLoaded", function() {
    let popupTimeout;

    // The popup class names to watch for
    const popupClasses = ['kl-teaser-RtZK4M', 'Teaser-pointer-Hn1zd'];

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if node has any of the popup classes
            const hasPopupClass = popupClasses.some(cls => node.classList.contains(cls));
            if (hasPopupClass && !document.body.classList.contains('popup-active')) {
              clearTimeout(popupTimeout);
              popupTimeout = setTimeout(() => {
                document.body.classList.add('popup-active');
              }, 2000); // delay in ms
            }
          }
        });
      });

      // If no popup elements are present, remove class
      const popupVisible = popupClasses.some(cls => document.querySelector('.' + cls));
      if (!popupVisible) {
        clearTimeout(popupTimeout);
        document.body.classList.remove('popup-active');
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

